// extracted by mini-css-extract-plugin
module.exports = {"container":"article-module--container--2gTJj"};